import { QueryKey } from 'react-query';
import { serviceKey } from '../service';
import { IO } from '../types';

export const queryEndpointKeys = {
  tasksList: [...serviceKey, 'tasks'],
  taskById: [...serviceKey, 'task-by-id'],
};

export const queryRequestKeys = {
  tasksList: (req: IO.GetTaskList['input']): QueryKey => [...queryEndpointKeys.tasksList, req],
  taskById: (req: IO.GetTaskList['input']): QueryKey => [...queryEndpointKeys.taskById, req],
};
